module.exports = __webpack_public_path__ + "201ac9fac80e067e070c902a2b0ba185.svg";